import styled from 'styled-components';

import searchIcon from '../../images/search-icon-purple.png';
import exploreImage from '../../images/icon-search.svg';
import clearIcon from '../../images/clear-search-icon.png';
import greyArrowRight from '../../images/grey-arrow-right.png';
import purpleArrow from '../../images/arrow-purple-down.svg';
import pinToBoard from '../../images/pin-to-board.svg';

const StylingContainer = styled.div.attrs({
  className: 'codebook',
})`
height: inherit;

div {
  height: inherit;
  font-size: inherit;
  background-color: white;
}

*:focus {
  outline:1px solid black;
}

.disabled{
  pointer-events: none;
}

div.cb_container {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  position:relative;
  height: inherit;
  font-size: inherit;
  max-height:calc(100vh - 130px); /*same as Collision*/
  padding: 0;
  background-color: white;
  input {
    color: #000 !important;
    width:auto;
    height: auto;
    box-shadow: none;
  }
  html {
    font-size: 16px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    height:100%;
  }
  h1 {
    font-size: 100%;
  }
  div {
    background-color: #f9f9f9;
  }
  label {
    width: auto;
  }
  br {
    content: " ";
    display:block;
    margin: 10px;
  }
  ul {
    list-style-type: none;
    padding:0;
    margin:0;
  }
  h5 {
    font-size: 20px;
    font-weight:normal;
    color: #0a0a0a;
    line-height: 28px;
  }
  @media screen and (max-width: 680px) {
    flex-direction: column;
    height: 100%;
  }
}

div.cb_container.main{
  div.filter_header {
    display: inline-block;
    box-sizing: inherit;
    width: 100%;
    margin: 0;
    border-bottom: 1px solid;
    h5, button{
      display: inline-block;
    }
    button {
      float: right;
    }
    h5 {
      margin: 0 0 8px 0;
    }
  }
  button.menu_reset {
    font-family: inherit;
    font-size:16px;
    line-height:16px;
    font-weight: bold;
    border: none;
    border-radius: 0;
    padding:4px;
    color:#686868;
    background-color: #eeeeee;
  }
}

section.cb_nav {
  position: relative;
  box-sizing: inherit;
  max-height: inherit;
  overflow-y: auto;
  overflow-x:hidden;
  @media screen and (max-width: 680px) {
    width:100%;
  }
  @media screen and (min-width: 681px) {
    width: 350px;
    height: inherit;
  }
}

nav {
  position: relative;
  box-sizing: border-box;
  padding:30px;
  padding-bottom:0;
  display: block;
  left: 0;
  width:100%;
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
  max-height:inherit; //80 outer container navbar + extra
}

section #cb_filters{
  display:  inline-block;
  color: #0a0a0a;
  vertical-align: top;
  margin-top: 10px;
  font-size: 13px;
  li {
      margin: 0;
  }
  p{
      margin-bottom: 0px !important;
  }
  #data_filters {
      margin:10px 0 0 0;
      ul {
        margin-bottom: 5px;
        &.filter_radio, &.filter_radio li {
          display:inline-block;
          margin-right: 20px;
        }
        &.filter_ckeckbox{
          margin-bottom: 5px;
        }
        &.filter_radio{
          margin-left: 10px;
        }
        &.filter_radio label{
          display: inline !important;
        }
      }
      p {
        margin-bottom: 0px !important;
      }
      li  label {
        font-weight: normal;
        font-size: 13px;
        line-height:24px;
        margin:0;
        margin-bottom: 5px;
      }
    }
  }

section#theme_menu {
  li {
    label {
      font-weight: normal;
      display: inline-block!important;
      width:80%;
      margin-bottom:5px!important;
    }
    input {
      vertical-align: top;
      height: 24px;
      margin:0 10px 0 0;
    }
  }
  span.span_italic {
    font-style: italic;
  }
}

*:focus {
  outline: none;
}

/* === div search === */

#cb_search, #cb_country_search{
  position: relative;
  width: 100%;
  display:  inline-block;
  background-color: #f9f9f9;
  vertical-align: top;
  input {
    height: 45px;
    margin: 10px 0;
  }
  #cb_search_text, #cb_country_search_text {
    border-radius: 0px;
    border: none;
    width:100%;
    margin-bottom: 10px;
    ::placeholder{
      padding-left: -20px;
      margin: 0;
      }
  }
  #cb_search_btn, #cb_country_search_btn {
    position: absolute;
    border-radius: 0px;
    border: none;
    height: 45px;
    width: 45px;
    top: 50%;
    right: 0;
    -moz-transform: translateY(-50%);
    -webkit-transform:  translateY(-50%);
    transform:  translateY(-50%);
    outline: none;
    margin-top: 10px;
    &.search {
      background: url(${searchIcon}) no-repeat;
      background-position: center;
      background-size: 30px;
    }
    &.clear {
      background: url(${clearIcon}) no-repeat;
      background-position: center;
    }
    &:hover {
      cursor: pointer;
    }
  }
}

.hidden {
  visibility: hidden;
}

.hide {
  display: none !important;
}

/*========Theme menu========*/

div#topic_list, div#data_filters {
  background-color: #f9f9f9;
  margin-top:10px;
  max-height: calc(100% - 40px); /* 100% containing element #cb_topics - header height 36px(ish) */
}

#theme_menu, #filter_menu {
  background-color: #f9f9f9;
  div.showMoreLess {
    font-size: 13px;
    text-decoration:underline;
    margin: 10px 0;
  }
  .limit {
    display: none !important;
  }
  input.filterSearch {
    width: calc(100%);
    height: 40px !important;
    padding: 0.5rem;
    background: #fefefe;
    outline: none;
    transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
    &:focus {
      box-shadow: 0 0 5px #cacaca;
    }
  }
  #cb_country_search_text{
    border: 1px solid #FC33FF;
  }
  #cb_country_search_btn{
    margin-top: 0;
    height: 40px;
    width: 40px;
    &.search {
      background-size: 10px!important;
    }
  }
  ul.dropdown-container {
    display: none;
    background-color: #f9f9f9;
    &.list {
      margin-left: 23px;
    }
  }
  .parent {
    line-height:24px;
    font-size: 13px;
    &.top {
      line-height:24px;
      font-size: 16px;
      font-weight: bold;
      margin:10px 0;
      &:hover {
        border-color: transparent;
        color: #5E00E6;
      }
    }
    &:before {
      content: "   ";
      white-space: pre;
      background-image: url(${purpleArrow});
      transform: rotate(-90deg);
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      vertical-align: middle;
      right: 0;
      top: 0;
      transition: all 0.25s ease;
      width: 24px;
      height: 24px;
    }
    &.list:before {
      background-size: 24px;
    }
    &.active:before{
      transform: rotate(0)!important;
      -webkit-transform: rotate(0);
    }
  }
  li, .parent {
    text-decoration: none;
    display:  block;
    margin-bottom: 0px;
    text-align: left;
    cursor: pointer;
    outline: none;
    color: #0a0a0a;
    font-size: 13px;
    line-height:24px;
    transition: all 0.25s ease;
    position: relative;
  }
  li.radial{
    padding-left: 1px;
  }
}

section#cb_search, section#cb_filters, section#cb_topics {
  padding-bottom: 15px;
}

/* ==== Content ==== */
/* ==== Blank content ==== */
section#cb_content, section#cb_blank_content {
  box-sizing: inherit;
  display:none;
  max-height: inherit; //80 outer container navbar + extra
}

section#cb_blank_content {
  position: relative;
  div {
    position: absolute;
    width: 30%;
    text-align: center;
    top: 50%;
    left: 50%;
    margin: -10% 0 0 -15%;
    background-color: inherit;
  }
  h6 {
    margin: 0;
    padding: 0;
    top:0;
    transform: translateY(90%);
    line-height: 20px;
    font-size: 14px;
  }
}

.dropdown-container a {
  height: 20px;
}

.explore {
  background-image:url(${exploreImage});
  background-size: 40px;
  background-repeat: no-repeat;
  background-position: center;
  height: 40px;
  width: 40px;
  display: inline-block;
}

#cb_content, #cb_blank_content {
  width:100%;
  max-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  > * {
    padding: 0 25px;
  }
}

#question_list{
  overflow: auto;
}

#cb_blank_content {
  display:block;
}

/* ==== Content ==== */
#cb_content, #cb_blank_content {
  color: #0a0a0a;
  vertical-align: top;
}
#cb_content ul{
  list-style-type: none;
}

#cb_content_header {
  margin: 20px 0;
  display: flex;
  flex-direction: column;
}

#cb_content_header a{
  position: relative;
  top: 50%;
  display: inline-block;
  -ms-transform: translateY(-50%, -50%);
  -webkit-transform: translateY(-50%, -50%);
  transform: translateY(-50%);
}

#cb_content_header a{
  color: #0a0a0a;
  font-size: 1.14em;
  font-weight: bold;
  text-decoration: none;
}

#cb_content_header h1{
  margin: 0;
  font-size: 24px;
}

#cb_content_header h1 a{
  font-family: franklin-gothic-urw, Helvetica, Arial, sans-serif;
  padding: 0;
  margin: 0;
  color: #29005a;
}

#question_filter{
  font-size: 13px;
  padding: 10px 0;
  display: inline-block;
  width: max-content;
  color: #0a0a0a;
}

#question_filter_btn {
  position: absolute;
  border-radius: 0px;
  border: none ;
  height: 18px;
  width: 20px;
  display:  inline-block;
  padding-left: 30px;
  background: url(${clearIcon}) no-repeat;
  background-position: center;
  background-size: 15px;
}

#question_filter.show{
  display:block;
}

#question_filter.hide{
display: none;
}

/* ==== question list ==== */

ul#question_list_ul, #question_list_ul *{
  padding-inline-start: 0px;
}
#question_list *{
  color: #0a0a0a;
}

#question_list div.question_title {
  padding: 14px 140px 14px 10px;
  margin-bottom: 2px;
  position:relative;
  font-size: 1.1em;
  min-height: 45px;
  cursor: pointer;
}
#question_list li{
  background-color: #eeeeee;
  line-height: 1.15;

}
#question_list a  {
  display: inline-block;
  padding-right: 0px;
  margin-bottom: 0;
  font-size: 14px;
}

#question_list a, #question_list div{
  text-decoration: none;
  background-color: #eeeeee;
}
#question_list li.active, #question_list div.question_title.active, #question_list div.question_title.active a {
  background-color: white;
  font-weight: bold;
  transition: all 0.5s ease;
}

#question_list_ul > li > div > a:before {
  content: "   ";
  white-space: pre;
  background-image: url(${greyArrowRight});
  background-repeat: no-repeat;
  position: absolute;
  vertical-align: middle;
  background-size: 7px auto;
  margin-left: 20px;
  right: 20px;
  top: 50%;
  transform: translateY(-50%) rotate(90deg);
  height: 12px;
  width: 7px;
  transition: all 0.25s ease;
}

#question_list_ul > li > div > a.active:before{
  background-position: 100% 100%;
  transform: translateY(-50%)  rotate(-90deg);
}

#question_list_ul > li > div > button {
  position: absolute;
  vertical-align: middle;
  right: 46px; /*20 + arrow width + 20 */
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.7em;
  margin: auto;
  background-color: #5E00E6;
  text-align: center;
  border: none;
  padding: 10px;
  color:#f9f9f9;  /* content colour */
  font-stretch: semi-condensed;
  transition: all 0.25s ease;
}

#question_list_ul > li > div > button:hover {
background-color: #0a0a0a;
}

#question_list_ul > li {
  position: relative;
}

#question_list_ul > li > div > button.pin_to_board {
  position: absolute;
  vertical-align: middle;
  right: 40px; /*20 + arrow width + 20 */
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.7em;
  margin: auto;
  background-color: white;
  text-align: center;
  border: none;
  padding: 10px;
  transition: all 0.25s ease;
  background:  url(${pinToBoard}) no-repeat;
  background-position: center;
}

#question_list_ul > li div a.active:after  {
  margin-top: -2px;
  transform: rotate(-90deg);
}

#question_list div ul.question_meta li{
  background-color: #f9f9f9;
  padding:  5px 0 5px 10px;
  font-weight: normal;
}

#question_list div ul.question_meta li a{
  color: #0a0a0a;
  width:100%;
}

#question_list div ul.question_meta li a:after{
  transform: rotate(0deg);
}

#question_list div ul.question_meta{
  display: none;
  background-color: none;
  transition: all 0.5s ease;
  background-color: #f9f9f9;
  padding: 10px 0;
}

#question_list div ul.question_meta.active {
  display: block;
}

#question_list div ul.question_meta li ul li{
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 0px;
}

#cb_content ul{
  width: 100%;
}

/* =======nav-arrows======== */
.hide {
  display: none;
}

#to_menu {
  background-image: $purpleArrow;
  transform: rotate(90deg);
  background-position: center;
  background-repeat: no-repeat;
  vertical-align: middle;
  right: 0;
  top: 0;
  transition: all 0.25s ease;
  width: 24px;
  height: 24px;
}

/* =======tick and radio boxes======== */

.tickbx {
  position: relative;
}
.tickbx label {
  display: inline-block;
  cursor: pointer;
  padding-left: 0;
}
 .tickbx input {
  margin-right: 0.64rem;
  height: 1.28rem;
  vertical-align: middle;
  display:none;
}
.tickbx label:before {
  content: "";
  cursor: pointer;
  vertical-align: middle;
  color: white;
  background-color: white;
  line-height: 1.1em;
  font-weight: bold;
  text-align: center;
  font-size: 11px;
  height: 16px;
  width: 16px;
  display: inline-block;
  border: 1px solid black;
  box-sizing: border-box;
  margin-right: 10px;
}

.tickbx.radial label:before {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  box-shadow:  0 0 0 0.5px  #5E00E6;
  border: 2px solid white;
}

.tickbx.checkbx input:checked  + label:before{
  border-color: #5E00E6;
  background-color: #5E00E6;
}
.tickbx.checkbx input:checked + label:after {
  content: "";
  left: 6px;
  top: 7px;
  width: 4px;
  height: 10px;
  position: absolute;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  background-color: #5E00E6;
}

.tickbx.radial input:checked + label:before {
  background-color: #5E00E6;
  border: 2px solid white;
  box-shadow: inset 1 0 0 0 1px  white;
}

li.tickbx.checkbx label, li.tickbx.radial label {
  font-weight: normal;
}

@media screen and (max-width: 680px) {
  #nav_arrows {
    position: relative;
    width: 100%;
    padding: 10px 20px;
  }
  #nav_arrows img {
  height: 20px;
  width: 10px;
  }
  #to_menu {
    transform: rotate(-180deg);
  }

  #to_content {
    float: right;
  }
  #to_menu:hover, #to_content:hover {
    cursor: pointer;
  }
}

`;

export default StylingContainer;



// WEBPACK FOOTER //
// ./app/containers/Codebook/CodebookContainer.js